/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 3bda4ef98b93c30afde6c7073b54117eccb7efb3ff9dd256c363ec67957859f4
 */
import {
  base_colorContentBorder,
} from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  border-top-color: ${base_colorContentBorder};
  border-top-style: solid;
  border-top-width: 1px;
  margin: 0;
  width: 100%;
`
